import { useUser } from "@js/apps/common/hooks";

import { useGetFreelancerLocationQuery } from "../../api";

export const useGetIsFreelancerLocationSupported = ({
  skip,
}: { skip?: boolean } = {}) => {
  const user = useUser();
  const { data, isLoading } = useGetFreelancerLocationQuery(
    { id: user?.freelancer as number },
    { skip: !user?.freelancer || skip },
  );

  return {
    isLoading,
    isFreelancerLocationSupported: data?.is_location_supported,
  };
};
